module.exports = require("live/services/i18n");